import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Decision, DecisionForm, Page, DecisionRow } from '../models';

@Injectable()
export class DecisionService {

  decisionsUrl = environment.dns + 'api/decisions/';

  constructor(private http: HttpClient) { }

  getPaginate(page: number, size: number, search: string = ""): Observable<Page<DecisionRow>> {
    return this.http.get<Page<DecisionRow>>(this.decisionsUrl + 'paginate?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search));
  }

  getListGroupByName(): Observable<Decision[]> {
    return this.http.get<Decision[]>(this.decisionsUrl + 'list/group-by-name');
  }

  getOne(id: number): Observable<Decision> {
    return this.http.get<Decision>(this.decisionsUrl + id);
  }

  add(decisionForm: DecisionForm): Observable<Decision> {
    return this.http.post<Decision>(this.decisionsUrl, decisionForm);
  }

  update(decisionForm: DecisionForm): Observable<Decision> {
    return this.http.put<Decision>(this.decisionsUrl, decisionForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.decisionsUrl + id);
  }
}
